// extracted by mini-css-extract-plugin
module.exports = {"item":"NewAddress_item__jRFBV"};